import { render } from "./Topbar.vue?vue&type=template&id=3b5b65f7&scoped=true"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"

import "./Topbar.vue?vue&type=style&index=0&id=3b5b65f7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b5b65f7"

export default script